var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mk-button mk-clamp-object",on:{"click":_vm.clickCallback}},[_c('div',{staticClass:"mk-clamp-object__dummy"},[_c('ArrowCollapseHorizontal')],1),_c('span',{staticClass:"mk-clamp-object__disc"},[_vm._v(" clamp ")])])}
var staticRenderFns = []

export { render, staticRenderFns }